<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4">
          <div class="vx-col">
            <vs-button @click="isCreateCity()" class="bg_l_green" v-has-permission="'CreateCity'">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateCity") }}
            </vs-button>
          </div>
        </div>
        <create-popup :show="showCreateCity" @finish="onfinish"></create-popup>
        <modify-popup
          :show="showModifyCity"
          :CityForModify="CityForModify"
          @finish="onfinish"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('CityName') },
                { title: $t('Priority') },
                { title: $t('CreateOn') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.name }}
                </td>
                <td style="width: 20%">
                  {{ row.priority }}
                </td>
                <td style="width: 30%">
                  {{ row.createOn }}
                </td>

                <td style="width: 30%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    v-has-permission="'ModifyCity'"
                    @click.prevent="isModifyCity(row)"
                    class="d-inline"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    v-has-permission="'DeleteCity'"
                    @click.prevent="isDeleteCity(row)"
                    class="d-inline mx-4"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions ,mapGetters} from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "",
  components: {
    CreatePopup,
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      showCreateCity: false,
      showModifyCity: false,
      gridDataSource: {
        type: "app",
        service: "Geography/api/CountriesQuery/cities",
      },
      gridSearchData: {},
      CityForModify: {},
    };
  },
  computed: {
    ...mapGetters({
      allProvince: "country/provinceList",
    }),
  },
  methods: {
    ...mapActions({
      deleteCity: "country/removeCity",
    }),
    isCreateCity() {
      this.showCreateCity = true;
    },
    onfinish() {
      this.showCreateCity = false;
      this.showModifyCity = false;
      this.$refs.grid.renderGrid();
    },
    isModifyCity(City) {
      this.CityForModify.id = City.id;
      this.CityForModify.name = City.name;
      this.CityForModify.priority = City.priority;
      this.CityForModify.parentId = this.allProvince.find(
          (x) => x.id === City.parentId
        );
      this.showModifyCity = true;
    },
    isDeleteCity(City) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteCity(City.id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
};
</script>
